/**
 * Shared phone-number helpers for click-to-dial UI.
 *
 * `isDialablePhone` is the single source of truth for "may we turn this string
 * into a softphone dial target?" — used by both `CallButton` and the inline
 * `PhoneNumber` primitive so the two never drift apart.
 */

/** True when the string looks like a Dutch or international number we can dial. */
export function isDialablePhone(n: string | null | undefined): boolean {
  if (!n) return false;
  const cleaned = n.replace(/[^\d+]/g, '');
  return /^(\+31|0031|0)\d{9}$/.test(cleaned) || /^\+\d{8,14}$/.test(cleaned);
}
